import React from 'react';

import TestDescription from '~/modules/Read/components/TestDescription';
import TestInstruction from '~/modules/Read/components/TestInstruction';
import TaskComponent from '~/modules/Read/components/TaskComponent';
import QuestionComponent from '~/modules/Read/components/QuestionComponent';
import TimerComponent from '~/modules/Read/components/TimerComponent';
import ResultComponent from '~/modules/Read/components/ResultComponent';

import styles from './assets/styles/styles.module.scss';

import { DISPLAY_WINDOW, INITIAL_STATE } from '~/constants/read_const';

class Read extends React.Component {
  state = INITIAL_STATE;

  getTextFromServer = async () => {
    const taskText = await(
      fetch(
        `/api/test_text/${this.state.ageValue}`,
        {
          method: 'GET',
          headers: {
            Accept: 'application/json',
            Authorization: 'dev dev',
            'Content-Type': 'application/json; charset=utf-8',
          },
          credentials: 'include',
        }
      ).then(res => res.json())
    );
    this.intervalId = setInterval(() => {
      let {
        timer: {
          seconds,
          minutes,
          hours
        }
      } = this.state;

      seconds++;
      if (seconds === 60) {
        seconds = 0;
        minutes++;
      }
      if (minutes === 60) {
        minutes = 0;
        hours++;
      }
      this.setState({ timer: { seconds, minutes, hours } });
    }, 1000);
    this.setState({ taskText, stage: DISPLAY_WINDOW.TASK, answersPicked: Array(taskText.questions.length).fill('answer1') });
  };

  finishTaskHandler = () => {
    clearInterval(this.intervalId);
    this.setState({ stage: DISPLAY_WINDOW.QUESTIONS });
  }

  finishQuestionBlockHandler = () => {
    this.setState({ stage: DISPLAY_WINDOW.RESULT });
  }

  answerPickHandler = (questionIndex, answerIndex) => {
    const {
      answersPicked
    } = this.state;
    const newAnswersPicked = [...answersPicked];
    newAnswersPicked[questionIndex] = answerIndex;
    this.setState({ answersPicked: newAnswersPicked });
  }

  ageChangeHandler = ageValue => {
    this.setState({ ageValue });
  };

  nameChangeHandler = event => {
    this.setState({ name: event.target.value });
  };

  getReadingSpeed = () => {
    const {
      timer: {
        hours,
        minutes,
        seconds,
      }
    } = this.state;
    return Math.floor(this.getWordsCount() * this.getUnderstandingPercentage() / (hours * 60 + minutes + seconds / 60));
  };

  restartTest = () => {
    this.setState(INITIAL_STATE);
  }

  getUnderstandingPercentage = () => {
    const {
      taskText: {
        questions
      },
      answersPicked
    } = this.state;
    return questions.reduce( (acc, { rightAnswer }, index) => {
      return acc + (`answer${rightAnswer}` === answersPicked[index] ? 1 : 0)
    }, 0) / questions.length;
  };

  getText = () => {
    const {
      taskText: {
        text
      }
    } = this.state;
    const tmp = document.createElement('div');
    tmp.innerHTML = text;
    return tmp.textContent;
  }

  getSignsCount = () => {
    return this.getText().length;
  };

  getWordsCount = () => {
    return this.getText().split(' ').length;
  }

  render() {
    const {
      loading,
      taskText,
      stage,
      timer,
      answersPicked,
      name,
      ageValue,
    } = this.state;
    const {
      INTRODUCTION,
      TASK,
      RESULT
    } = DISPLAY_WINDOW;
    return (
      <React.Fragment>
        {(stage === INTRODUCTION && (
          <React.Fragment>
            <TestDescription
              onNameChangeHandler={this.nameChangeHandler}
              onAgeChangeHandler={this.ageChangeHandler}
              ageValue={ageValue}
            />
            <TestInstruction
              gameStartClick={this.getTextFromServer}
              loading={loading}
            />
          </React.Fragment>
        )) ||
        (stage === RESULT && (
          <ResultComponent
            name={name}
            wordsPerMinute={this.getReadingSpeed()}
            understandingPercentage={this.getUnderstandingPercentage()}
            signsCount={this.getSignsCount()}
            time={timer}
            ageCategory={ageValue}
            restartTestHandler={this.restartTest}
          />
        )) ||
        (
          <div className={styles['task-block']}>
            {(stage === TASK &&
              (
                <TaskComponent
                  taskText={taskText}
                  finishTaskHandler={this.finishTaskHandler}
                />
              )
            ) ||
              <QuestionComponent
                questionsData={taskText.questions}
                answerPickHandler={this.answerPickHandler}
                answersPicked={answersPicked}
                finishQuestionBlockHandler={this.finishQuestionBlockHandler}
              />}
            <TimerComponent timer={timer} active={stage === TASK ? 0 : 1}/>
          </div>
        )}
      </React.Fragment>
    );
  }
}

export default Read
